import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { CommonMessages, PlainLinkComponent, UserService, WindowRef } from '@frontend/vanilla/core';
import { DarkModeService } from '@frontend/vanilla/shared/dark-mode';

import { PortalTrackingService } from '../tracking/tracking-resource.service';
import { ZendeskLiveChatResourceService } from './zendesk-resource.service';

@Component({
    selector: 'pt-pull-chat-button',
    templateUrl: 'zendesk-live-chat.component.html',
    imports: [NgClass, PlainLinkComponent],
})
export class ZendeskLiveChatComponent implements OnInit {
    zendeskData: any;
    @Input() liveChatText: any;
    @Input() isFromLiveChatLink = false;
    @Input() enableAcquisitionEnhancements = false;
    @Input() liveChatBtnColor = false;
    isZendeskAvailable: boolean;
    AccountorIpBlocked: boolean;
    isZendeskDisabled: boolean;
    @Input() isContact: boolean = false;
    config: any = {};
    _window: any;
    classname: any = '';
    constructor(
        public service: ZendeskLiveChatResourceService,
        private changeDetectorRef: ChangeDetectorRef,
        private user: UserService,
        private windowRef: WindowRef,
        private portalTrackingService: PortalTrackingService,
        public darkModeService: DarkModeService,
        public commonMessages: CommonMessages,
    ) {}

    ngOnInit(): void {
        this._window = <any>this.windowRef.nativeWindow;
        this.isZendeskAvailable = this.isContact ? true : false;
        if (this._window.entainsprinklr) {
            this._window.entainsprinklr.defaultDataSetup();
            const inputData = this._window.entainsprinklr.keysToInclude;
            const queryParams = this._window.entainsprinklr.requestConfig;
            const data = { inputData, queryParams };
            this.service.getSprinklrSettings(data).subscribe((response) => {
                this.prepareInitData(response);
                if (this.zendeskData?.sprinklrData?.sprinklrData?.appId) {
                    if (this.zendeskData?.sprinklrData?.sprinklrData?.appId && this.zendeskData?.sprinklrData?.sprinklerScriptSrc) {
                        this._window.entainsprinklr.setInitData(this.zendeskData);
                        this.changeDetectorRef.markForCheck();
                    } else {
                        //TO-Do logger if needed or console.log('sprinklr hash key generation failed');
                    }
                }
            });
        } else {
            this.service.getInitValuesZendeskChat().subscribe((response) => {
                this.prepareInitData(response);
                if (this._window.gvczendesk) {
                    this._window.gvczendesk.setInitData(this.zendeskData);
                    this.changeDetectorRef.markForCheck();
                }
            });
        }
    }

    prepareInitData(response: any) {
        this.zendeskData = response;
        this.isZendeskAvailable = true;
        this.isZendeskDisabled =
            this.zendeskData.sunshineConfig?.isZendeskAvailable == 'False' || this.zendeskData?.isSprinklrEnabled == false ? true : false;
        if (this.user && this.user.accountId) {
            if (response.posApiResponse.token) sessionStorage.setItem('zd-jwt-' + this.user.accountId, response.posApiResponse.token);
        }
        if (this.zendeskData.posApiResponse == '1000' || this.zendeskData.posApiResponse == '1001') {
            this.AccountorIpBlocked = true;
            if (this.isContact && document.getElementById('chat')) {
                document.getElementById('chat')!.classList.add('disabled');
            }
            this.trackingEventsService(this.zendeskData.posApiResponse == '1001' ? 'blocked ip disabled' : 'account name disabled', 'chat window');
        }
        if ((this.AccountorIpBlocked || this.isZendeskDisabled) && this.zendeskData?.content?.zendeskChat?.messages?.classname != undefined)
            this.classname = this.zendeskData?.content?.zendeskChat?.messages?.classname;
    }

    livechatclick() {
        if (
            this.zendeskData?.isSprinklrEnabled &&
            !this.isZendeskDisabled &&
            this._window.entainsprinklr &&
            this._window.sprChatSettings &&
            !this._window.sprChat?.loaded
        )
            this._window.entainsprinklr.openChat();
        else if (this.zendeskData.enabled) {
            //todo call zendesk load a token
            this._window.gvczendesk?.livechatclick(this.zendeskData);
            if (this.user.claims && this.user.claims.get('nameidentifier')) {
                this.config.userId = this.user.claims.get('nameidentifier');
            }
        }
    }

    trackingEventsService(actionEvent: string, eventDetails: string) {
        this.portalTrackingService.trackEvents({
            CategoryEvent: 'hcc',
            LabelEvent: 'livechat',
            ActionEvent: actionEvent,
            EventDetails: eventDetails,
        });
    }
}
